/* eslint-disable react/prop-types */
import React, { useEffect, useState, useMemo } from "react";
import { useFirebaseStorage } from "utils/hooks/useFirebaseStorage";
import {
	convertQueue,
	postReSeparateRecord,
	getRecordDetail,
	putDeleteRecord,
	getErrorExportFile,
	getSchedulePaginationList,
	deleteRecordFile,
	getQuestionList,
	putBatchRetry,
	getQuerySeparateRecordSelection,
	putEditCheck,
	postUploadQuestionMockExam,
	putDeleteFile,
} from "api/convert";
import { getSpecificationProductFilter } from "api/specification";
import { v4 as uuidv4 } from "uuid";
import { useMachine } from "@xstate/react";
import { fetchMachine, FetchEventType, FetchStates } from "machines/fetchMachine";
import {
	sliceTableData,
	setSelectOptions,
	filterEmptyObject,
	getSchoolYear,
	getStartDay,
	getEndDay,
} from "utils/common";
import { Table, Pagination, Button, Icon, Upload, Select, Loading } from "common-components";
import { Modal, Tabs, Image, Checkbox, DatePicker } from "antd";
import { getTime, format, set } from "date-fns";
import queryString from "query-string";
import { useLocation, useHistory } from "react-router-dom";
import openNotificationWithIcon from "utils/hooks/useNotification";
import { Breadcrumb, FileCheck } from "components";

import {
	StyledValidationQuestions,
	UiQuesDetail,
	UiPopupContainer,
	StyledModal,
	UiButtons,
	UiRuleModalContent,
	UiLink,
	UiLoadingBox,
} from "./ValidationQuestions.style";
import { EDU_NAME, SUBJECT_NAME } from "constants/index";
import { useBoolean, useSelections } from "ahooks";
import { getQuestionHtml } from "api/bank";
import moment from "moment";
import { API_BATCH_QUEUE } from "constants/index";

const { Header, Body, Row, Item } = Table;

const { RangePicker } = DatePicker;

const dateFormat = "YYYY-MM-DD";

const breadcrumbList = [
	{
		icon: "unarchive",
		name: "檢定試題",
		path: "/validationQuestions",
	},
];
const filterTypeOptions = [
	{
		name: "顯示全部題目",
		value: null,
	},
	{
		name: "僅顯示成功",
		value: 0,
	},
	{
		name: "僅顯示失敗",
		value: 1,
	},
];

const finishedStatusOptions = [
	{
		name: "顯示全部作業狀況",
		value: null,
	},
	{
		name: "僅顯示完成作業",
		value: true,
	},
	{
		name: "僅顯示未完成作業",
		value: false,
	},
];

export const ValidationQuestions = () => {
	const history = useHistory();

	// 取得 匯出列表
	const [stateGetSeparateRecord, sendGetSeparateRecord] = useMachine(fetchMachine, {
		services: {
			fetchData: async (_c, event) => {
				setIsLoading(true);
				const {
					year,
					version,
					edu,
					subject,
					book,
					source,
					subSource,
					isChecked,
					failType,
					userName,
					fileName,
					startDateTime,
					EndDateTime,
				} = searchParams;

				const payload = {
					failType,
					productType: 5,
					pagenumber: pageState.currentPage,
					pagesize: pageState.limit,
					version,
					year,
					education: edu,
					subjectCode: subject,
					bookCode: book,
					sourceCode: source,
					subsourceCode: subSource,
					isChecked,
					userName,
					fileName,
					StartDateTime: startDateTime.toISOString(),
					EndDateTime: EndDateTime.toISOString(),
				};

				if (payload.failType === "all") delete payload.failType;
				const { data, isSuccess, message } = await getSchedulePaginationList(payload);
				const { isFinished, totalcount, records } = data;
				setIsLoading(false);
				return {
					data: records,
					totalcount,
					isSuccess,
					message,
					isFinished,
				};
			},
			deleteData: async (_c, event) => await putDeleteRecord(event.fileUID),
		},
	});

	const { data, totalcount, isFinished } = stateGetSeparateRecord.context.result || {};
	const [checkList, setCheckedList] = useState([]);

	// const [filterData, setFilterData] = useState("all");

	// 翻頁相關功能
	const [pageState, setPageState] = useState({
		currentPage: 1,
		limit: 100,
	});

	const pageChange = (currentPage, pageSize) => {
		setPageState({
			...pageState,
			currentPage,
			limit: pageSize,
		});
		goTop();
	};

	// 學制科目轉換成中文
	// const transformEduSubject = (eduSubject) => {
	// 	if (!eduSubject) return "";
	// 	const edu = eduSubject.substring(0, 1);
	// 	const subject = eduSubject.substring(1, 3);
	// 	return EDU_NAME[edu] + SUBJECT_NAME[subject];
	// };

	// 觸發 下載URL
	// const downloadHandle = (item) => {
	// 	const { downloadUrl, fileName } = item;
	// 	const link = document.createElement("a");
	// 	link.href = downloadUrl;
	// 	// link.target = "_blank";
	// 	link.download = fileName;
	// 	link.click();
	// };

	// 設定 定時 30秒 更新列表資訊
	// useEffect(() => {
	// 	fetchRecords();
	// const interval = setInterval(() => {
	// 	fetchRecords();
	// }, 1000 * 30);
	// return () => clearInterval(interval);
	// }, [pageState.currentPage, pageState.limit]);

	// 試題列表 視窗 ----
	const [detailModalVisible, { toggle: setDetailModalToggle, setFalse: setDetailModalFalse }] = useBoolean(false);
	const [detailModalData, setDetailModalData] = useState({
		data: null,
		fileUID: null,
	});

	const [detailModalCanDownload, setDetailModalCanDownload] = useState(false);

	const closeDetailModal = () => {
		setDetailModalFalse();
		setSpecUID(null);
	};

	// 翻頁相關功能
	const [detailPageListState, setDetailListPage] = useState({
		currentPage: 1,
		limit: 100,
	});

	const detailPageChange = (currentPage, pageSize) => {
		setDetailPage({
			...setDetailListPage,
			currentPage,
			limit: pageSize,
		});
	};

	const onDetailPopupHandle = (item) => {
		sendGetQuestionList(FetchEventType.Fetch, {
			fileUID: item?.uid,
		});
		setDetailModalToggle();
		setDetailListPage({
			currentPage: 1,
			limit: 100,
		});
		setFileUID(item?.uid);
		setSpecUID(item?.specUID);
	};

	// 試題詳情 視窗 ------
	const showCodeList = ["CORE_ACCOMPLISHMENT", "PERFORMANCE", "LEARN_CONTENT", "KNOWLEDGE"];

	const [detailPopup, setDetailPopup] = useState({
		visible: false,
	});

	const [detailEduSubject, setDetailEduSubject] = useState("");
	const [bookTagPath, setBookTagPath] = useState("");
	const [bookTagIsListen, setBookTagIsListen] = useState(false);
	const [detailPage, setDetailPage] = useState(1);
	const [fileUID, setFileUID] = useState(null);

	const [stateRecordDetail, sendRecordDetail] = useMachine(fetchMachine, {
		services: {
			fetchData: async (_c, event) => {
				const { data } = await getRecordDetail(event.eduSubject, event.fileUID);
				return {
					detailList: data,
				};
			},
		},
	});

	const { detailList } = stateRecordDetail.context.result || {};

	const isCheckAll = useMemo(() => {
		if (!data) return false;
		if (checkList.length === data.length && data.length !== 0) return true;
		return false;
	}, [checkList, data]);

	const fetchRecords = (clearCheck = false) => {
		sendGetSeparateRecord(FetchEventType.Fetch);
		if (clearCheck) setCheckedList([]);
	};
	const targetDetail = useMemo(() => {
		if (!detailList) return {};
		return detailList[detailPage - 1];
	}, [detailPage, detailList]);

	const toggleDetailVisible = (item) => {
		if (!detailPopup.visible) {
			setDetailPage(1);
			setBookTagPath("");
			setBookTagIsListen(false);
			const { eduSubject, uid } = item;
			sendRecordDetail(FetchEventType.Fetch, {
				eduSubject,
				fileUID: uid,
			});
			setDetailEduSubject(eduSubject);
		}
		setDetailPopup({
			...detailPopup,
			visible: !detailPopup.visible,
		});
	};

	const onDetailPageChange = (currentPage) => {
		setDetailPage(currentPage);
	};

	const targetSelectOptions = useMemo(() => {
		let result = [];
		if (Object.keys(targetDetail).length === 0 || !targetDetail.detailImage) return result;

		result =
			targetDetail?.detailImage.map((item) => ({
				name: item.name,
				value: item.path,
				isListen: false,
			})) || [];
		if (targetDetail.soundtracks) {
			const listenList = targetDetail.soundtracks.map((item) => ({
				name: item.name,
				value: item.path,
				isListen: true,
			}));
			result = result.concat(listenList);
		}
		return result;
	}, [targetDetail]);

	const onSelectBookTag = (path) => {
		const isListen = targetSelectOptions.find((item) => item.value === path).isListen;
		setBookTagPath(path);
		setBookTagIsListen(isListen);
	};

	useEffect(() => {
		if (targetDetail && JSON.stringify(targetDetail) !== "{}") {
			sendGetQuestionHtml(FetchEventType.Fetch, {
				eduSubject: detailEduSubject,
				uid: targetDetail.uid,
			});
		}
	}, [targetDetail]);

	const [stateGetQuestionHtml, sendGetQuestionHtml] = useMachine(fetchMachine, {
		services: {
			fetchData: async (_c, event) => {
				const { data, isSuccess, message } = await getQuestionHtml(event.eduSubject, event.uid);
				return {
					questionHtml: data,
					isSuccess,
					message,
				};
			},
		},
	});

	const { questionHtml } = stateGetQuestionHtml.context.result || {};

	useEffect(() => {
		if (targetSelectOptions.length === 0) return;
		setBookTagPath(targetSelectOptions[0].value);
	}, [targetSelectOptions]);

	// 上傳 試題相關 ----
	const initsearchProductDetailData = {
		year: getSchoolYear() + "",
		edu: "",
		subject: "",
		version: "",
	};

	const initUrlParams = queryString.parse(useLocation().search);
	const [urlParams, setUrlParams] = useState(initUrlParams);
	const [uploadPopup, setUploadPopup] = useState(Object.keys(urlParams).length > 0 ? true : false);
	const [files, setFiles] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const { upload } = useFirebaseStorage();
	const [specUID, setSpecUID] = useState(null);
	const [mode, setMode] = useState("upload");

	const [searchProductDetailData, setSearchProductDetailData] = useState({
		year: "109",
		edu: "",
		subject: "",
		version: "",
	});

	const lockRuleSelection = useMemo(() => {
		return Object.keys(urlParams).length > 0;
	}, [urlParams]);

	const toggleUploadPopupVisible = () => {
		setMode("upload");
		setUploadPopup(!uploadPopup);
		setUrlParams({});
		setSearchProductDetailData(initsearchProductDetailData);
		setFiles([]);
	};

	const toggleEditPopupVisible = () => {
		setMode("edit");
		setUploadPopup(!uploadPopup);
		setUrlParams({});
		setFiles([]);
	};

	const doConvertQueue = async (payload) => {
		const { isSuccess, message } = await convertQueue(payload);
		if (!isSuccess) {
			openNotificationWithIcon("error", message);
		} else {
			setSpecUID(null);
		}
	};

	const params = {
		paper: false,
		mockExam: false,
		onlineTest: false,
		quick: false,
		selfTaughtProduct: false,
		freeProduct: false,
		equationDojo: false,
		queueType: API_BATCH_QUEUE.QUEUE_TYPE.create,
		isRefesth: false,
		productType: API_BATCH_QUEUE.PRODUCT_TYPE.validationQuestions,
		collectedEdition: false,
		validation: true,
		optionQuick: false,
		vocabularyTest: false,
	};
	const reUploadQues = async (item) => {
		const { uid, itemUID, fileUID, fileUrl, fileName, fileUrl2, fileName2, specUID, cms, queS_TYPE } = item;

		const payload = {
			uid,
			itemUID: itemUID ?? "",
			fileUID,
			fileUrl,
			fileName,
			fileUrl2,
			fileName2,
			specUID,
			cms: cms ?? "",
			queS_TYPE,
		};

		const params = {
			queueType: API_BATCH_QUEUE.QUEUE_TYPE.create,
		};
		setReSubmitLoading(true);
		const { isSuccess, message } = await postReSeparateRecord(payload, params);
		setReSubmitLoading(false);
		if (isSuccess) {
			sendGetQuestionList(FetchEventType.Fetch, {
				fileUID: detailModalData?.fileUID,
			});
			openNotificationWithIcon("success", "成功重新轉檔");
		} else {
			openNotificationWithIcon("error", message);
		}
	};

	const doDeleteQueue = async (item) => {
		const { isSuccess, message } = await deleteRecordFile(item?.uid);
		if (isSuccess) {
			openNotificationWithIcon("success", "刪除成功");
			sendGetQuestionList(FetchEventType.Fetch, {
				fileUID: detailModalData?.fileUID,
			});
		} else {
			openNotificationWithIcon("error", message);
		}
	};

	// const [stateRecord, sendRecord] = useMachine(fetchMachine, {
	// 	services: {
	// 		fetchData: async () => {
	// 			const res = await getScheduleList();
	// 			const { records, isFinished } = res.data;
	// 			return {
	// 				records,
	// 				isFinished,
	// 			};
	// 		},
	// 		deleteData: async (_c, event) => await putDeleteRecord(event.fileUID),
	// 	},
	// });

	const submitFiles = async () => {
		if (files.length === 0) return;
		setIsLoading(true);

		const array = [];

		await Promise.all(
			files.map(async (file) => {
				const uid = uuidv4();
				await upload(`convert/${uid}_${file.name}`, file).then((res) => {
					array.push({
						fileUrl: res.url,
						fileName: file.name,
						uid,
						specUID,
					});
				});
				// await doConvertQueue(payload);
			}),
		).then(async () => {
			await postUploadQuestionMockExam(array, params).then((response) => {
				const { isSuccess, message } = response;
				if (isSuccess) {
					openNotificationWithIcon("success", "上傳成功");
				} else {
					openNotificationWithIcon("error", message);
				}
			});
		});

		setUploadPopup(false);
		setUrlParams({});
		setSearchProductDetailData(initsearchProductDetailData);
		setFiles([]);
		// sendRecord(FetchEventType.Fetch);
		setIsLoading(false);
		fetchRecords();
	};

	const [stateProductDetail, sendProductDetail] = useMachine(fetchMachine, {
		services: {
			fetchData: async () => {
				const result = await getSpecificationProductFilter(searchProductDetailData.year);
				const selection = result?.data?.selection || {};
				const specList = result?.data?.specList || [];
				return {
					yearMap: setSelectOptions(selection?.yearMap) || [],
					eduMap: setSelectOptions(selection?.eduMap) || [],
					subjectMap: selection?.subjectMap || [],
					versionMap: selection?.versionMap || [],
					specList,
				};
			},
		},
	});

	const { yearMap, eduMap, subjectMap, versionMap, specList } = stateProductDetail.context.result || {};

	const subjectOptions = useMemo(() => {
		if (!subjectMap || !searchProductDetailData.edu) return [];
		return setSelectOptions(subjectMap[searchProductDetailData.edu]);
	}, [searchProductDetailData.edu]);

	const versionOptions = useMemo(() => {
		if (!versionMap || !searchProductDetailData.edu) return [];
		return setSelectOptions(versionMap[searchProductDetailData.edu]);
	}, [searchProductDetailData.edu]);

	const filterSpecList = useMemo(() => {
		const { year, edu, subject, version } = searchProductDetailData;
		if (!(year || edu || subject || version) || !specList) return [];
		return setSelectOptions(
			specList
				.filter((item) => item.eduSubject === `${edu}${subject}` && item.year === year && item.version === version)
				.map((item) => ({ name: item.name, code: item.uid })),
		);
	}, [searchProductDetailData, specList]);

	const onUpdateRuleChange = (type, value) => {
		if (type === "year") {
			setSearchProductDetailData({
				...searchProductDetailData,
				[type]: value,
				edu: "",
				subject: "",
				version: "",
			});
		} else if (type === "edu") {
			setSearchProductDetailData({
				...searchProductDetailData,
				[type]: value,
				subject: "",
				version: "",
			});
		} else {
			setSearchProductDetailData({
				...searchProductDetailData,
				[type]: value,
			});
		}
		setSpecUID(null);
	};

	const changeFileList = (value) => {
		setFiles(value);
	};

	useEffect(() => {
		fetchRecords();
		sendProductDetail(FetchEventType.Fetch);
	}, [pageState.currentPage, pageState.limit]);

	useEffect(() => {
		if (!searchProductDetailData.year) return;
		setSearchProductDetailData({
			...searchProductDetailData,
			subject: "",
			version: "",
		});
		sendProductDetail(FetchEventType.Fetch);
	}, [searchProductDetailData.year]);

	// 刪除按鈕 相關
	const [deletePopupState, setDeletePopupState] = useState(false);
	const [reSubmitLoading, setReSubmitLoading] = useState(false);

	const deleteHandle = (item) => {
		sendGetSeparateRecord(FetchEventType.Delete, {
			fileUID: item.uid,
		});
		setCheckedList([]);
	};

	const onConfirmHandle = (item) => {
		deleteHandle(item);
		setDeletePopupState(false);
	};

	const onConfirmHandle_ques = (item) => {
		doDeleteQueue(item);
		setDeletePopupState(false);
	};

	const checkHandler = (e, item) => {
		const checked = e.target.checked;

		let nextData = [...checkList];
		if (checked) {
			if (nextData.some((data) => data.uid === item.uid)) return;
			nextData = [...nextData, item];
			setCheckedList([...nextData]);
		} else {
			const dataIndex = nextData.findIndex((data) => data.uid === item.uid);
			nextData.splice(dataIndex, 1);
			setCheckedList([...nextData]);
		}
	};

	const IsChecked = (item) => {
		if (checkList.length === 0) return false;
		return checkList.some((data) => data.uid === item.uid);
	};
	const checkListAll = (e) => {
		const checked = e.target.checked;
		if (checked) {
			setCheckedList([...data]);
		} else {
			setCheckedList([]);
		}
	};

	// const onFilterChange = (value) => {
	// 	setPageState({
	// 		currentPage: 1,
	// 		limit: 100,
	// 	});
	// 	setFilterData(value);
	// };

	// const canRetryArray = ["DownloadFail", "ReadDocFail", "ConvertFail", "Warning", "UploadFail", "Exception"];

	// setReSubmitLoading(true);
	// await onReSubmitHandle(item);
	// setReSubmitLoading(false);

	const queueReloadFile = async () => {
		const retryFile = checkList.map((item) => {
			return item?.uid;
		});
		setIsLoading(true);
		const response = await putBatchRetry(retryFile);
		const { isSuccess } = response;
		if (isSuccess) {
			openNotificationWithIcon("success", "批次重傳完成");
			setCheckedList([]);
			fetchRecords();
		} else {
			openNotificationWithIcon("error", "批次重傳失敗");
		}
		setIsLoading(false);
	};

	const queueDeleteFile = async () => {
		setIsLoading(true);
		const canDelFile = checkList.filter((item) => item.message === "拆解完成");
		const array = canDelFile.map((item) => {
			return item?.uid;
		});
		await putDeleteFile(array).then((res) => {
			const { isSuccess, message } = res;
			if (isSuccess) {
				openNotificationWithIcon("success", "批次刪除完成");
				setPageState({ ...pageState, currentPage: 1 });
			} else {
				openNotificationWithIcon("error", message);
			}
			setIsLoading(false);
			fetchRecords(true);
		});
	};

	// 取得 下載url 相關
	const [stateGetErrorExportFile, sendGetErrorExportFile] = useMachine(fetchMachine, {
		services: {
			fetchData: async (_c, event) => {
				setIsLoading(true);
				const { data, isSuccess, message } = await getErrorExportFile(event.fileUID);
				const { downloadUrl } = data;

				if (isSuccess) {
					setIsLoading(false);
					const link = document.createElement("a");
					link.href = downloadUrl;
					// link.target = "_blank";
					link.download = fileName;
					link.click();
				} else {
					openNotificationWithIcon("error", message);
				}

				return {
					downloadUrl,
					isSuccess,
					message,
				};
			},
		},
	});

	const { downloadUrl, isSuccess, message } = stateGetSeparateRecord.context.result || {};

	const [fileName, setFileName] = useState("");

	const getFileUrl = () => {
		if (!fileUID) return null;
		sendGetErrorExportFile(FetchEventType.Fetch, {
			fileUID: fileUID,
		});
		// setFileName(item?.fileName);
	};

	const handlerDownloadUrl = (fileName, fileUrl) => {
		const link = document.createElement("a");
		link.href = fileUrl;
		// link.target = "_blank";
		link.download = fileName;
		link.click();
	};

	const isCanDownload = (item) => {
		if (!item) return null;
		let res = true;
		if (!item?.data | (item?.data?.length === 0)) res = false;
		item?.data &&
			item.data.forEach((record) => {
				if (!record?.isFinished) res = false;
			});
		return res;
	};

	const isCanDownload_zip = (array) => {
		if (!array | (array.length === 0)) return false;
		const filterArray = array.filter((record) => {
			return record?.message !== "入庫完成";
		});
		return filterArray.length !== 0;
	};

	const goTop = () => {
		const scroll = document.querySelector(".ScheduleListTable > .body");
		scroll.scrollTop = 0;
	};

	// 取得 試題列表
	const [stateGetQuestionList, sendGetQuestionList] = useMachine(fetchMachine, {
		services: {
			fetchData: async (_c, event) => {
				setIsLoading(true);
				const { data, isSuccess, message } = await getQuestionList(event.fileUID);
				if (isSuccess) {
					setIsLoading(false);
					setDetailModalData({
						data: data,
						fileUID: event.fileUID,
					});
				}
				// const { isFinished, totalcount, records } = data;
				// setIsLoading(false);
				return {
					// data: records,
					isSuccess,
					message,
					isFinished,
				};
			},
		},
	});

	const onRetryQuesHandle = async (item) => {
		const { fileUrl, fileName, uid, specUID } = item;
		const payload = {
			fileUrl,
			fileName,
			uid,
			specUID,
		};
		await doConvertQueue(payload);
	};

	// －－－－－－－－ 下拉選單 相關 －－－－－－－

	const nowSchoolYear = getSchoolYear();
	const today = new Date();
	const before1Month = new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000);

	const [selectionData, setSelectionData] = useState({});
	const [searchParams, setSearchParams] = useState({
		failType: null,
		year: nowSchoolYear + "",
		version: null,
		edu: null,
		subject: null,
		book: null,
		source: null,
		subSource: null,
		isChecked: null,
		fileName: "",
		userName: "",
		startDateTime: getStartDay(before1Month),
		EndDateTime: getEndDay(today),
	});

	const changeSearchParams = (key, value) => {
		if (key === "edu") {
			setSearchParams({
				...searchParams,
				[key]: value,
				subject: null,
				version: null,
			});
		} else {
			setSearchParams({
				...searchParams,
				[key]: value,
			});
		}
	};

	useEffect(() => {
		fetchRecords();
	}, [searchParams?.failType, searchParams?.isChecked]);

	// 取得 匯出列表
	const [statGgetQuerySeparateRecordSelection, sendGetQuerySeparateRecordSelection] = useMachine(fetchMachine, {
		services: {
			fetchData: async (_c, event) => {
				const { data, isSuccess, message } = await getQuerySeparateRecordSelection();
				const { bookMap, eduMap, eduSubject, eduVersion, sourceMap, subSourceMap, yearMap } = data;
				setSelectionData({ bookMap, eduMap, eduSubject, eduVersion, sourceMap, subSourceMap, yearMap });
				return {
					data,
					isSuccess,
					message,
					isFinished,
				};
			},
		},
	});

	// 取得 下拉選單資料
	useEffect(() => {
		sendGetQuerySeparateRecordSelection(FetchEventType.Fetch);
	}, []);

	const subjectOption = useMemo(() => {
		if (!selectionData?.eduSubject | !searchParams?.edu) return [];
		return setSelectOptions(selectionData.eduSubject[searchParams.edu]);
	}, [selectionData.eduSubject, searchParams.edu]);

	const versionOption = useMemo(() => {
		if (!selectionData?.eduVersion | !searchParams?.edu) return [];
		return setSelectOptions(selectionData.eduVersion[searchParams.edu]);
	}, [selectionData.eduVersion, searchParams.edu]);

	// 編輯 是否已完成作業
	const doEditCheck = async (fileUID, isChecked) => {
		const { data, isSuccess, message } = await putEditCheck(fileUID, isChecked);
		if (isSuccess) {
			fetchRecords();
		} else {
			openNotificationWithIcon("error", message);
		}
	};

	const checkWorkDoneHandler = (e, item) => {
		const checked = e.target.checked;
		doEditCheck(item?.uid, checked);
	};

	const handleDateChange = (e) => {
		if (!e) return;
		setSearchParams({
			...searchParams,
			startDateTime: new Date(e[0]._d),
			EndDateTime: getEndDay(new Date(e[1]._d)),
		});
	};

	return (
		<StyledValidationQuestions id="MockExam">
			<div className="titleControlBox">
				<div className="flexStartBox">
					<Breadcrumb data={breadcrumbList} />
				</div>
				<div className="searchToolBar">
					<div className="flexStartBox">
						<Select
							placeholder="請選擇轉檔狀態"
							options={filterTypeOptions}
							value={searchParams?.failType}
							onChange={(val) => {
								changeSearchParams("failType", val);
							}}
							allowClear={false}
						/>
						<Select
							placeholder="請選擇作業狀態"
							options={finishedStatusOptions}
							value={searchParams?.isChecked}
							onChange={(val) => {
								changeSearchParams("isChecked", val);
							}}
							allowClear={false}
						/>
					</div>
					<div className="flexEndBox">
						<Button.IconButton variant="green" full={false} iconName="restart_alt" onClick={queueReloadFile}>
							批次重傳檔案
						</Button.IconButton>
						<Button.IconButton variant="red" full={false} iconName="delete_forever" onClick={queueDeleteFile}>
							批次刪除檔案
						</Button.IconButton>
						<Button.IconButton variant="blue" full={false} iconName="cloud_upload" onClick={toggleUploadPopupVisible}>
							上傳試題
						</Button.IconButton>
					</div>
				</div>

				<div className="selectionBar">
					<Select
						placeholder="請選擇學年度"
						options={setSelectOptions(selectionData?.yearMap)}
						value={searchParams.year}
						onChange={(val) => {
							changeSearchParams("year", val);
						}}
						allowClear={false}
					/>
					<Select
						placeholder="請選擇學制"
						options={setSelectOptions(selectionData?.eduMap)}
						value={searchParams.edu}
						onChange={(val) => {
							changeSearchParams("edu", val);
						}}
					/>
					<Select
						placeholder="請選擇科目"
						options={subjectOption}
						disabled={!searchParams?.edu}
						value={searchParams.subject}
						onChange={(val) => {
							changeSearchParams("subject", val);
						}}
					/>
					<Select
						placeholder="請選擇版本"
						options={versionOption}
						disabled={!searchParams?.edu}
						value={searchParams.version}
						onChange={(val) => {
							changeSearchParams("version", val);
						}}
					/>
					<Select
						placeholder="請選擇冊次"
						options={setSelectOptions(selectionData?.bookMap)}
						value={searchParams.book}
						onChange={(val) => {
							changeSearchParams("book", val);
						}}
					/>
					<Select
						placeholder="請選擇出處"
						options={setSelectOptions(selectionData?.sourceMap)}
						value={searchParams.source}
						onChange={(val) => {
							changeSearchParams("source", val);
						}}
					/>
					<Select
						placeholder="請選擇來源"
						options={setSelectOptions(selectionData?.subSourceMap)}
						value={searchParams.subSource}
						onChange={(val) => {
							changeSearchParams("subSource", val);
						}}
					/>
				</div>

				<div className="dateFilterBox">
					<RangePicker
						value={[moment(searchParams?.startDateTime, dateFormat), moment(searchParams?.EndDateTime, dateFormat)]}
						onChange={handleDateChange}
						allowClear={false}
					/>
				</div>

				<div className="searchBox">
					<div className="searchInputBox">
						<label>檔案名稱：</label>
						<input
							type="text"
							placeholder="請輸入檔案名稱"
							onChange={(e) => changeSearchParams("fileName", e.target.value)}
						/>
					</div>

					<div className="searchInputBox">
						<label>上傳者名稱：</label>
						<input
							type="text"
							placeholder="請輸入上傳者名稱"
							onChange={(e) => changeSearchParams("userName", e.target.value)}
						/>
					</div>

					<Button variant="orange" onClick={fetchRecords}>
						搜尋
					</Button>

					<Button variant="green" onClick={fetchRecords}>
						重新整理
					</Button>
				</div>

				{/* ------------------- 上傳試題 ------------------- */}

				<Modal
					width={600}
					visible={uploadPopup}
					onCancel={toggleUploadPopupVisible}
					onOk={submitFiles}
					zIndex={1003}
					title={mode === "upload" ? "上傳試題" : "上傳修題"}
					footer={
						<UiButtons>
							<Button variant="white" full={false} onClick={toggleUploadPopupVisible} Key="cancel" loading={isLoading}>
								取消
							</Button>
							<Button
								variant="orange"
								full={false}
								onClick={submitFiles}
								Key="ok"
								loading={isLoading}
								disabled={files.length === 0 || !specUID}>
								確認
							</Button>
						</UiButtons>
					}>
					{mode === "upload" && (
						<UiRuleModalContent>
							<div className="ruleDetail">
								<Select
									value={searchProductDetailData.year}
									disabled={lockRuleSelection}
									options={yearMap}
									placeholder="請選擇年度*"
									onChange={(val) => {
										onUpdateRuleChange("year", val);
									}}
									allowClear={false}
								/>
								<Select
									value={searchProductDetailData.edu || null}
									disabled={lockRuleSelection}
									options={eduMap}
									placeholder="請選擇學制*"
									onChange={(val) => {
										onUpdateRuleChange("edu", val);
									}}
								/>
								<Select
									value={searchProductDetailData.subject || null}
									disabled={lockRuleSelection}
									options={subjectOptions}
									placeholder="請選擇科目*"
									onChange={(val) => {
										onUpdateRuleChange("subject", val);
									}}
								/>
								<Select
									value={searchProductDetailData.version || null}
									disabled={lockRuleSelection}
									options={versionOptions}
									placeholder="請選擇版本*"
									onChange={(val) => {
										onUpdateRuleChange("version", val);
									}}
								/>
							</div>
							<div className="ruleDetail">
								<Select
									value={specUID}
									disabled={lockRuleSelection}
									options={filterSpecList}
									placeholder="請選擇入庫規格*"
									onChange={(val) => {
										setSpecUID(val);
									}}
								/>
							</div>
						</UiRuleModalContent>
					)}
					<Upload
						fileList={files}
						multiple={true}
						onChange={changeFileList}
						prompt={
							<>
								僅限上傳999個Microsoft Word 檔<br />
								(副檔名 : .doc/.docx)
							</>
						}
						acceptFileType=".doc,.docx"
					/>
				</Modal>
			</div>

			{/* ------------------- 試題入庫列表 ------------------- */}

			<Table margin="3" className={"ScheduleListTable"}>
				<Header className={"header"}>
					<Row>
						<Item className="checkboxItem" flex="0.1">
							<Checkbox
								indeterminate={checkList.length !== 0 && !isCheckAll}
								checked={isCheckAll}
								onChange={(event) => {
									checkListAll(event);
								}}
							/>
						</Item>
						<Item flex="1.5">檔案名稱</Item>
						<Item flex="0.75">檔案狀態</Item>
						<Item flex="1">日期</Item>
						<Item flex="1">規格名稱</Item>
						<Item flex="1">上傳者</Item>
						<Item flex="2.75">操作</Item>
						<Item flex="0.75">完成作業</Item>
					</Row>
				</Header>
				<Body className={"body"}>
					{data?.length > 0 &&
						data.map((item, index) => {
							return (
								<Row key={uuidv4()}>
									<Item className="checkboxItem" flex="0.1">
										<Checkbox
											checked={IsChecked(item)}
											onChange={(event) => {
												checkHandler(event, item);
											}}
										/>
									</Item>
									<Item flex="1.5">{item?.fileName}</Item>
									<Item flex="0.75">{item?.message}</Item>
									<Item flex="1">{format(getTime(new Date(item?.systemTime)), "yyyy-MM-dd HH:mm")}</Item>
									<Item flex="1">
										{item?.specName ? (
											<UiLink
												className="link"
												onClick={() => {
													history.push(`/ruleSearchDetail/${item?.specUID}`);
												}}>
												{item.specName}
											</UiLink>
										) : (
											""
										)}
									</Item>
									<Item flex="1">{item?.userName}</Item>
									<Item flex="2.75" className="controlBox">
										<Button.IconButton
											variant={item?.message !== "拆解完成" ? "ui01" : "orange"}
											disabled={item?.message !== "拆解完成"}
											full={false}
											iconName="visibility"
											onClick={() => onDetailPopupHandle(item)}>
											看更多
										</Button.IconButton>

										<Button.IconButton
											disabled={!item?.fileUrl}
											variant={item?.fileUrl ? "blue" : "ui01"}
											full={false}
											iconName="save_alt"
											onClick={() => handlerDownloadUrl(item?.fileName, item?.fileUrl)}>
											下載
										</Button.IconButton>

										<Button.Popconfirm
											variant={item?.uid ? "red" : "ui01"}
											disabled={!item?.uid}
											title="確定要刪除嗎?"
											block={false}
											full={false}
											onCancel={() => setDeletePopupState(false)}
											onConfirm={() => onConfirmHandle(item)}
											onClick={() => setDeletePopupState(true)}
											visible={deletePopupState}>
											<Icon name="delete_forever" mr="2" />
											刪除
										</Button.Popconfirm>
									</Item>
									<Item flex="0.75">
										<Checkbox
											checked={item?.isChecked}
											onChange={(event) => {
												checkWorkDoneHandler(event, item);
											}}
										/>
									</Item>
								</Row>
							);
						})}
				</Body>
			</Table>
			<Pagination
				total={totalcount || 0}
				defaultCurrent={1}
				current={pageState.currentPage}
				onChange={pageChange}
				defaultPageSize={pageState.limit}
			/>

			{/* ------------------- 試題詳情列表頁 ------------------- */}

			<StyledModal
				visible={detailModalVisible}
				zIndex={1001}
				onCancel={closeDetailModal}
				// getContainer={document.getElementById("ScheduleListPage")}
				id={"detailModal"}
				title={"試題列表"}
				footer={
					detailModalData?.data && (
						<>
							<Button.IconButton variant="blue" full={false} iconName="cloud_upload" onClick={toggleEditPopupVisible}>
								上傳修題
							</Button.IconButton>
							<Button
								// className='reportModalBtn'
								variant={isCanDownload_zip(detailModalData?.data) ? "blue" : "ui02"}
								disabled={!isCanDownload_zip(detailModalData?.data)}
								onClick={() => getFileUrl(detailModalData?.data)}>
								下載所有錯誤題目
							</Button>
						</>
					)
				}>
				<Table margin="3" className={"questionListTable"}>
					<Header>
						<Row>
							<Item flex="2">檔案名稱</Item>
							<Item flex="2">題目UID</Item>
							<Item flex="1">檔案狀態</Item>
							<Item flex="1.25">日期</Item>
							<Item flex="2">操作</Item>
						</Row>
					</Header>
					<Body>
						{detailModalData?.data &&
							sliceTableData(detailModalData?.data, detailPageListState.currentPage, detailPageListState.limit).map(
								(item, index) => {
									return (
										<Row key={index}>
											<Item flex="2">{item?.fileName}</Item>
											<Item flex="2">{item?.itemUID}</Item>
											<Item flex="1">{item?.message}</Item>
											<Item flex="1.25">{format(getTime(new Date(item?.systemTime)), "yyyy-MM-dd HH:mm")}</Item>
											<Item flex="2" className={"controlBox"}>
												<Button.IconButton
													variant={item?.message !== "入庫完成" ? "ui01" : "orange"}
													disabled={item?.message !== "入庫完成"}
													full={false}
													iconName="visibility"
													onClick={() => toggleDetailVisible(item)}>
													題目詳情
												</Button.IconButton>

												<Button.IconButton
													disabled={!item?.failedUrl && !item?.fileUrl}
													variant={item?.failedUrl || item?.fileUrl ? "blue" : "ui01"}
													full={false}
													iconName="save_alt"
													onClick={() => {
														handlerDownloadUrl(item?.downloadName, item?.failedUrl || item?.fileUrl);
													}}>
													下載
												</Button.IconButton>

												<Button.Popconfirm
													variant={"red"}
													title="確定要刪除嗎?"
													block={false}
													full={false}
													onCancel={() => setDeletePopupState(false)}
													onConfirm={() => onConfirmHandle_ques(item)}
													onClick={() => setDeletePopupState(true)}
													visible={deletePopupState}>
													<Icon name="delete_forever" mr="2" />
													刪除
												</Button.Popconfirm>

												<Button.IconButton
													variant={item?.isCMSFinished ? "ui01" : "green"}
													full={false}
													iconName="restart_alt"
													type="outLined"
													// loading={reSubmitLoading}
													disabled={item?.isCMSFinished}
													onClick={async () => {
														await reUploadQues(item);
													}}>
													重新轉檔
												</Button.IconButton>
											</Item>
										</Row>
									);
								},
							)}
					</Body>
				</Table>
				<Pagination
					total={detailModalData?.data?.length || 0}
					defaultCurrent={1}
					current={detailPageListState.currentPage}
					onChange={detailPageChange}
					defaultPageSize={detailPageListState.limit}
				/>
			</StyledModal>

			{/* ------------------- 單一題目詳情 ------------------- */}

			<UiQuesDetail
				visible={detailPopup.visible}
				onCancel={toggleDetailVisible}
				getContainer={document.getElementById("ScheduleListPage")}
				width="75%"
				zIndex={1010}
				footer={
					<Pagination
						textcolor="#000"
						total={detailList?.length || 0}
						defaultPageSize={1}
						variant="white"
						current={detailPage}
						onChange={onDetailPageChange}
					/>
				}>
				<UiPopupContainer id="quesTab">
					<Tabs
						defaultActiveKey="1"
						tabBarExtraContent={
							<>
								{targetDetail?.questionPdf ? (
									<Button.IconButton
										variant="blue"
										type="outLined"
										iconName="picture_as_pdf"
										onClick={() => {
											window.open(targetDetail.questionPdf, "_blank");
										}}>
										PDF
									</Button.IconButton>
								) : (
									""
								)}
							</>
						}>
						<Tabs.TabPane tab={"線上測驗解析結果"} key="1">
							{questionHtml && <FileCheck key={questionHtml} questionHtml={questionHtml}></FileCheck>}
						</Tabs.TabPane>

						<Tabs.TabPane
							tab={
								<>
									<Icon name="widgets" />
									解析狀態
								</>
							}
							key="2">
							<div className="container">
								<div className="content">
									<div className="title">題目</div>
									<div className="bookTag">
										<Select
											label="解析書籤名稱:"
											options={targetSelectOptions}
											value={bookTagPath}
											onChange={(val) => {
												onSelectBookTag(val);
											}}
										/>
									</div>
									<div className="img">
										{bookTagIsListen ? (
											<audio controls src={bookTagPath || "error"}>
												Your browser does not support the
												<code>audio</code> element.
											</audio>
										) : (
											<Image
												src={bookTagPath || "error"}
												preview={{
													getContainer: document.getElementById("quesTab"),
												}}
												fallback="data:image/png;base64,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"
											/>
										)}
									</div>
								</div>
								<div className="content">
									<div className="title">基本資料</div>
									<div className="meta">
										編號:
										<span className="metaContent">{targetDetail?.uid}</span>
									</div>
									{targetDetail?.metadata &&
										targetDetail.metadata.map((meta, index) => {
											return (
												<div className="meta" key={index}>
													{`${meta.name}: `}
													{meta.content.map((content, contentIndex) => {
														return (
															<span className="metaContent" key={contentIndex}>
																{new Set(showCodeList).has(meta.code) ? content.code : content.name}
															</span>
														);
													})}
												</div>
											);
										})}
								</div>
							</div>
						</Tabs.TabPane>

						<Tabs.TabPane
							tab={
								<>
									<Icon name="visibility" />
									檢視更多
								</>
							}
							key="3">
							<div className="container">
								<div className="content">
									<div className="title">題目</div>
									<div className="img">
										<Image
											src={targetDetail?.questionImage || "error"}
											preview={{
												getContainer: document.getElementById("quesTab"),
											}}
											fallback="data:image/png;base64,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"
										/>
									</div>
									<ul className="info">
										<li>
											入庫時間:{" "}
											{targetDetail?.createTime && format(new Date(targetDetail.createTime), "yyyy-MM-dd HH:mm")}
										</li>
										<li>最後修改時間: {targetDetail?.updateTime}</li>
									</ul>
								</div>
								<div className="content">
									<div className="title">基本資料</div>
									<div className="meta">
										編號:
										<span className="metaContent">{targetDetail?.uid}</span>
									</div>
									{targetDetail?.metadata &&
										targetDetail.metadata.map((meta, index) => {
											return (
												<div className="meta" key={index}>
													{`${meta.name}: `}
													{meta.content.map((content, contentIndex) => {
														return (
															<span className="metaContent" key={contentIndex}>
																{new Set(showCodeList).has(meta.code) ? content.code : content.name}
															</span>
														);
													})}
												</div>
											);
										})}
								</div>
							</div>
						</Tabs.TabPane>
					</Tabs>
				</UiPopupContainer>
			</UiQuesDetail>

			{/* ------------------- Loading 圖示 ------------------- */}

			{isLoading ? (
				<UiLoadingBox>
					<Loading />
				</UiLoadingBox>
			) : null}
		</StyledValidationQuestions>
	);
};
